import { render, staticRenderFns } from "./ListCustomActivities.vue?vue&type=template&id=39c549c6"
import script from "./ListCustomActivities.vue?vue&type=script&lang=js"
export * from "./ListCustomActivities.vue?vue&type=script&lang=js"
import style0 from "./ListCustomActivities.vue?vue&type=style&index=0&id=39c549c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports